import { useGoogleStatus, useSyncRuns } from './queries'
import { spendHint, spendShown, spendState, type SpendState } from './spend'

/** The spend rule for a screen (lib/spend.ts): whether spend, profit and ROAS
 *  show numbers or a dash, and the reason when a dash. While the Google status
 *  or the sync runs are still on their way the state reads "unlinked", so
 *  `ready` says when it can be trusted; screens draw spend cells as a dash
 *  until then rather than a $0.00. */
export function useSpend(): { state: SpendState; shown: boolean; hint: string | null; ready: boolean } {
  const google = useGoogleStatus()
  const sync = useSyncRuns()
  const state = spendState({ status: google.data, runs: sync.runs })
  const ready = !google.isLoading && !sync.isLoading
  return { state, shown: ready && spendShown(state), hint: spendHint(state), ready }
}
